/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent form (last 3 races weighted most heavily)`)
};

const es_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma reciente (últimas 3 carreras con mayor peso)`)
};

const de_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Form (letzte 3 Rennen am stärksten gewichtet)`)
};

const nl_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente vorm (laatste 3 races het zwaarst gewogen)`)
};

const fr_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forme récente (les 3 dernières courses pondérées plus fortement)`)
};

const it_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma recente (ultime 3 gare con peso maggiore)`)
};

const pt_br2_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma recente (as 3 últimas corridas têm maior peso)`)
};

const pt_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma recente (últimas 3 corridas com maior peso)`)
};

const ja_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直近のフォーム（直近3レースに最も重みを付加）`)
};

const zh_about_optimizer_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期状态（最近3场比赛权重最高）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_li1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_li1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_li1", locale)
	if (locale === "en") return en_about_optimizer_li1(inputs)
	if (locale === "es") return es_about_optimizer_li1(inputs)
	if (locale === "de") return de_about_optimizer_li1(inputs)
	if (locale === "nl") return nl_about_optimizer_li1(inputs)
	if (locale === "fr") return fr_about_optimizer_li1(inputs)
	if (locale === "it") return it_about_optimizer_li1(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_li1(inputs)
	if (locale === "pt") return pt_about_optimizer_li1(inputs)
	if (locale === "ja") return ja_about_optimizer_li1(inputs)
	return zh_about_optimizer_li1(inputs)
};